export function createMap<T, U extends keyof T>(items: T[], key: U) {
  const map = new Map<T[U], T>();

  for (const item of items) {
    map.set(item[key], item);
  }

  return map;
}
